<template>
    <CardView title="Policies" ttyId="15" :filterControls="filterControls"></CardView>
</template>

<script>
    import CardView from '@/components/CardView.vue'
    export default {
        name: 'PolicyCards',
        components: {
            CardView
        },
        data() {
            return {
                filterControls: [{ matId: 848 }, { matId: 845 }]
            }
        },
    }
</script>
<style scoped>
</style>
